module.exports = __webpack_public_path__ + "img/img-shopping.9eb3c418.png";